export default __webpack_public_path__ + "static/media/box_white.2a3cb9f5.svg";